import * as React from 'react';

const setupInstructionsSrc = `${window.postbuildEnv.CDN_URL}/images/illustrations/setup-instructions.svg`
const setupInstructionsGenericSrc = `${window.postbuildEnv.CDN_URL}/images/illustrations/setup-instructions-generic.svg`

const classCodeLinksPdf = `${window.postbuildEnv.CDN_URL}/documents/setup_instructions_pdfs/class_code_links.pdf`

interface SetupInstructionsProps {
  close: (event) => void;
  back: (event) => void;
  classroom: any;
}

export const SetupInstructions = ({ close, back, classroom }: SetupInstructionsProps) => {
  let downloadHref = classCodeLinksPdf
  let imageSrc = setupInstructionsGenericSrc
  let download = true
  if (classroom?.students?.length) {
    downloadHref = `/teachers/classrooms/${classroom.id}/student_logins`
    imageSrc = setupInstructionsSrc
    download = false
  }
  const downloadImgLink = <a aria-label="Download student logins and setup instructions" className="focus-on-light" download={download} href={downloadHref} rel="noopener noreferrer" target="_blank"><img alt="" src={imageSrc} /></a>
  const downloadLink = <a className="quill-button outlined green medium focus-on-light" download={download} href={downloadHref} rel="noopener noreferrer" target="_blank">Download PDF</a>
  return (
    <div className="create-a-class-modal-content">
      <div className="create-a-class-modal-body modal-body setup-instructions">
        <h3 className="title">Download student logins and setup instructions</h3>
        <p>This PDF includes usernames and passwords for each student and instructions for accessing their Quill accounts.</p>
        <div className="content-container">
          {downloadImgLink}
          {downloadLink}
        </div>
      </div>
      <div className="create-a-class-modal-footer">
        <div className="buttons-container">
          <button className="quill-button outlined green medium focus-on-light" onClick={back} type="button">Back</button>
          <button className="quill-button contained green medium focus-on-light" onClick={close} type="button">Done</button>
        </div>
      </div>
    </div>
  )
}

export default SetupInstructions
